import { render } from "./BallotCard.vue?vue&type=template&id=a6b77740"
import script from "./BallotCard.vue?vue&type=script&lang=js"
export * from "./BallotCard.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__